import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { User } from '../../types/user.model';

@Component({
  selector: 'mmb-web-app-add-looking-for-items-modal',
  templateUrl: './add-looking-for-items-modal.component.html',
  styleUrls: ['./add-looking-for-items-modal.component.scss']
})
export class AddLookingForItemsModalComponent implements OnInit {
  @Output() addSuccess: EventEmitter<string> = new EventEmitter<string>();
  @Output() closed: EventEmitter<any> = new EventEmitter<any>();
  @Input() user: User;

  form: UntypedFormGroup;

  constructor() {
  }

  ngOnInit() {
  }

  onClose() {
    this.closed.emit();
  }
}
